<template>
  <div class="mall-shop-content" ref="mallShopCon">
    <div class="search-con">
      <div class="input-con" @click="onSearch">
        <span class="icon"></span>
        <span>请输入店铺名称</span>
      </div>
    </div>

    <!--<div class="advertisement-con">
      <van-swipe class="advertisement-swipe" :autoplay="3000" indicator-color="#999" >
        <van-swipe-item v-for="(item, i) in adList" :key="i" @click="adClick(item)">
          <img class="advertisement-swipe-img" :src="item.filePath+'?imageView2/0/w/700/h/250'" alt="">
        </van-swipe-item>
      </van-swipe>
    </div>-->
    <swipe-ad :reqData="{adType: 'SYS_SG', version: 3 }"></swipe-ad>
    
    <div class="mall-shop-body">
      <div class="shop-list-con">
        <div class="shop-tabs"  :class="{'shop-tabs-on-top': shopTabsOnTop}">
          <div class="shop-tab" :class="{'shop-tab-active': shopListActive===1}" @click="shopTabChange('PERSONALIZED')">
            <div class="tab-title">精选</div>
            <div class="line-con"><i class="line"></i></div>
          </div>
          <div class="shop-tab" :class="{'shop-tab-active': shopListActive===2}" @click="shopTabChange('TIME')">
            <div class="tab-title">最新</div>
            <div class="line-con"><i class="line"></i></div>
          </div>
          <div class="shop-tab" :class="{'shop-tab-active': shopListActive===3}" @click="shopTabChange('vip')">
            <div class="tab-title">VIP店</div>
            <div class="line-con"><i class="line"></i></div>
          </div>
        </div>
        <!--店铺列表-->
        <div class="shop-list">
          <!--<van-pull-refresh v-model="shopListRefreshLoading" @refresh="onShopListRefresh"></van-pull-refresh>-->
          <van-list
              v-model="shopListLoading"
              :finished="shopListFinished"
              :error.sync="isError"
              error-text="请求失败，点击重新加载"
              finished-text="没有更多了"
              @load="getShopList"
          >
            <div class="list" v-for="(item,i) in shopList" :key="i">
              <div class="list-left" @click="goShopDetail(item.shopId)">
                <div class="img-con">
                  <img class="img" :src="item.shopAvatar+'?imageView2/0/w/110/h/110'" alt="">
                  <div class="is-vip" v-if="item.isVip"></div>
                </div>
              </div>
              <div class="text-con" @click="goShopDetail(item.shopId)">
                <div class="list-title"><span class="name">{{ item.shopName }}</span></div>
                <div class="list-text">{{ item.signature || '&nbsp;'}}</div>
                <div class="sub-text"><span class="num">关注:{{ item.focuseUserCnt }}</span><span class="num">商品:{{ item.goodsCnt }}</span><span class="num">人气:{{ item.goodsSalesVolume }}</span></div>
              </div>
              <div class="btn-con">
                <!--自己为店主时不能关注自己-->
                <div v-if="!item.isShopOwner" class="btn " :class="item.isFocused?'yes':'no'" @click="changeFocusShop(item.shopId, i)"></div>
              </div>
            </div>

            <!--
              <div class="list" v-for="(item,i) in shopList" :key="i+i">
                <div class="list-left" @click="goShopDetail(item.shopId)">
                  <div class="img-con">
                    <img class="img" :src="item.shopAvatar+'?imageView2/0/w/110/h/110'" alt="">
                    <div class="is-vip" v-if="item.isVip"></div>
                  </div>
                </div>
                <div class="text-con" @click="goShopDetail(item.shopId)">
                  <div class="list-title"><span class="name">{{ item.shopName }}</span></div>
                  <div class="list-text">{{ item.signature || '&nbsp;'}}</div>
                  <div class="sub-text"><span class="num">关注:{{ item.focuseUserCnt }}</span><span class="num">商品:{{ item.goodsCnt }}</span><span class="num">人气:{{ item.goodsSalesVolume }}</span></div>
                </div>
                <div class="btn-con">
                  &lt;!&ndash;自己为店主时不能关注自己&ndash;&gt;
                  <div v-if="!item.isShopOwner" class="btn " :class="item.isFocused?'yes':'no'" @click="changeFocusShop(item.shopId, i)"></div>
                </div>
              </div>
            -->

          </van-list>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import { listAd, listNav, tipsList } from '@/api/mall/mallContent'
import { mallShop, focusShop } from '@/api/mall/mallShop'
import SwipeAd from '@/components/swipeAd'
export default {
  components:{
    SwipeAd,
  },
  data(){
    return {
      // 广告 , 导航 ，tip广告
      adList: [],
      navData: [],
      tipsData: [],

      //店铺列表
      shopOrderBy: 'PERSONALIZED',// 排序条件：TIME-开店时间；POPULARITY-热度；PERSONALIZED-个性化推荐（精选）
      shopSortOrder: 'DESC', // ASC-升序；DESC-降序
      shopIsVip: '', // 当值为 true 时，限定搜索 vip 店铺
      shopList: [],
      shopPage: 1,
      shopSize: 40,
      shopListRefreshLoading: false,
      shopListLoading: false,
      shopListFinished: false,
      isError: false,

      shopListActive: 1,// 店铺tabs标签状态
      shopTabsOnTop: false,//店铺tabs标签是否固定在顶部
      mallShopCon: null,//监听滚动条的容器
    }
  },
  created(){
    this.get_AD_and_Nav() // 获取广告、导航

    window.scrollTo(0,0)

    window.setTimeout(()=>{
      this.mallShopCon = this.$refs.mallShopCon;
      this.mallShopCon.addEventListener('scroll',this.mallShopContentScroll)
    },300)
  },
  methods: {
    // 跳转至 搜索
    onSearch(){
      this.$router.push({ name: 'sgSearch', query: {type: 'sgShop'} })
    },

    mallShopContentScroll(){
      let scrollTop = this.mallShopCon.scrollTop; // mallContent 容器的滚动条高度
      this.shopTabsOnTop = (scrollTop>186);
    },


    // 获取 商城首页的 广告 、 导航
    get_AD_and_Nav() {
      listAd({adType: "SYS", clientType: "H5"}).then(res => { //获取广告
        this.adList = res.data
      });
    },

    // 店铺列表的 tab 标签切换
    shopTabChange(orderBy){
      this.shopPage = 1;//初始化分页
      if(this.shopListFinished){
        this.shopListFinished = false; //初始化分页
      }
      this.shopIsVip = '';// 搜索条件：清空 是否vip
      this.shopOrderBy = orderBy;//排序字段
      this.shopSortOrder = 'DESC';// 默认降序
      if(orderBy==='PERSONALIZED'){ //精品
        this.shopListActive = 1
      }else if(orderBy==='TIME'){//最新
        this.shopListActive = 2
      }else if(orderBy==='vip'){// 是否VIP
        this.shopIsVip = true;
        this.shopOrderBy = ''; // 搜索条件：清空 排序字段
        this.shopSortOrder = ''; // 搜索条件：清空 排序字段 升降序
        this.shopListActive = 3
      }
      // this.getShopList()
    },

    // 获取店铺列表
    getShopList(){
      let req = {
        shopSysType: 'SHOP_SYS_TYPE_GOODS',
        openStatus: 'OPEN', // 开业状态：OPEN-营业；CLOSED-停业；FORCE_CLOSED-强制停业；
        page: this.shopPage,
        size: this.shopSize,
      };
      (this.shopOrderBy!=='') && (req.orderBy = this.shopOrderBy);
      (this.shopSortOrder!=='') && (req.sortOrder = this.shopSortOrder);
      (this.shopIsVip!=='') && (req.isVip = this.shopIsVip);
      mallShop(req).then(res=>{
        // this.shopList = res.data.items
        if(res.data.totalCount){ //是否有数据
          let arr = res.data.items
          // 如果是第一页需手动制空列表
          if (this.shopPage === 1){
            this.shopList = [];
          }
          // 把请求到的数据添加到列表
          this.shopList = this.shopList.concat(arr)
          this.shopListLoading = false
          if(res.data.totalPages===this.shopPage){ // 到达最大页
            this.shopListFinished = true;
          }
          this.shopPage++

        }else {
          if (this.shopPage === 1){
            this.shopList = [];
          }
          this.shopListLoading = false;
          this.shopListFinished = true;
        }
      }).catch(() => {
        this.isError = true;
      })
    },

    //  店铺 关注、取关
    changeFocusShop(shopId, i){
      focusShop({shopId}).then(res=>{
        // 修改本地数据，避免列表刷新后定位不准确：
        this.shopList[i].isFocused = !this.shopList[i].isFocused;
      })
    },

    // 跳转至店铺详情页
    goShopDetail(shopId){
      this.$router.push({name: 'sgShopIndex', query: {shopId: shopId}})
    },


  }
}
</script>

<style lang="less" scoped>
@url: '../../../assets/mall/';

.mall-shop-content{
  position: absolute;
  width: 100%;
  top: 0;bottom: 0;
  overflow-y: auto;
  padding-top: 12px;
  .search-con{
    display: flex;justify-content: center;align-items: center;
    height: 36px;
    width: 100%;
    padding: 0 12px 10px;
    .input-con{
      display: inline-flex;
      height: 30px;
      border-radius: 15px;
      background-color: #fff;
      font-size: 12px;
      color: #999;
      align-items: center;
      width: 351px;
      border: 1px solid #ddd;
      .icon{
        margin: 0 12px;
        display: inline-flex;width: 14px;height: 14px;
        background: url("@{url}search-icon.png") no-repeat 50% 50%;background-size: 100%;
      }
    }

  }
  .advertisement-con{
    padding: 0 12px;
    .advertisement-swipe{
      border-radius: 5px;
      z-index: 10;
      width: 351px;
      height: 175px;
      .advertisement-swipe-img{
        width: 100%;height: 100%;
      }
    }
  }
  .mall-shop-body{
    .shop-list-con{
      position: relative;z-index: 0;padding-top: 44px;
      .shop-tabs{
        position: absolute;top: 0;width: 100%;background-color: #fff;
        display: flex;justify-content: center;align-items: center;
        height: 44px;font-size: 16px;color: #666;
        &.shop-tabs-on-top{
          position: fixed;z-index: 100;top: 0;
        }
        .shop-tab{
          position: relative;z-index: 0;height: 100%;padding: 0 5px;
          flex: 1;display: inline-flex;justify-content: center;align-items: center;
          &.shop-tab-active {
            color: #1585f3;
            .line-con{
              position: absolute;z-index: 0;bottom: 0;width: 100%;height: 4px;
              display: flex;justify-content: center;align-items: center;
              .line{
                display: block;width: 50px;height: 2px;
                background-color: #1585f3;
              }
            }
          }
        }
      }
      .shop-list{
        .list{
          display: flex;width: 375px;height: 76px;
          box-shadow: 0 1px 0 0 #edecec;
          .list-left{
            width: 76px;height: 76px;
            display: inline-flex;justify-content: center;align-items: center;
            .img-con{
              position: relative;z-index: 0;width: 55px;height: 55px;
              .img{
                display: block;width: 100%;height: 100%;border-radius: 50%;
              }
              .is-vip{
                position: absolute;z-index: 0;top: -7px;left: 2px;
                width: 20px;height: 17px;
                background: url("@{url}shop-vip.png") no-repeat 50% 50%;
                background-size: 100%;
              }
            }
          }

          .text-con{
            flex: 1;color: #2b2b2b;
            overflow: hidden;padding-top: 10px;
            .list-title{
              font-size: 14px;color: #000;font-weight: bold;
              .name{padding-right: 12px;}
            }
            .list-text{
              font-size: 10px;padding: 2px 0;overflow: hidden;
              text-overflow: ellipsis;white-space: nowrap;color: #999;
            }
            .sub-text{
              font-size: 10px;color: #999;
              .num{
                padding-right: 26px;
                &:last-child{
                  padding-right: 0;
                }
              }
            }
          }
          .btn-con{
            width: 70px;
            display: inline-flex;justify-content: center;align-items: center;
            .btn{
              height: 21px;
              &.yes{
                width: 55px;
                background: url("@{url}shop-follow-yes.png") no-repeat 50% 50%;
                background-size: 54px 21px;
              }
              &.no{
                width: 44px;
                background: url("@{url}shop-follow-no.png") no-repeat 50% 50%;
                background-size: 44px 21px;
              }
            }
          }
        }
      }
    }
  }
}
</style>